<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FlightDataForm
        ref="flightDataForm"
        v-model="flightDataFormModel"
        label-width="10em"
        formMode="edit"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-registration_symbol-set="autocompleteRegistrationSymbolSet"
      />
    </template>
    <template #footer>
      <!--<EditDialogFooter
        @update="clickUpdate"
      />-->
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FlightDataForm from '@/components/organisms/dialog/data/FlightDataForm.vue'
// import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    FlightDataForm
    // EditDialogFooter
  },
  props: {
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      flightDataFormModel: {
        billing_ym: undefined,
        action_type_name: undefined,
        action_type: undefined,
        model_code: undefined,
        callsign: undefined,
        route_code: undefined,
        operator_code: undefined,
        registration_symbol: undefined,
        cargo_passenger_type: undefined,
        flight_purpose_code: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        actual_time_arrival: undefined,
        actual_time_departure: undefined,
        irregular: undefined,
        divert_airport_code: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
    // console.log('FlightDataEditDialog.mounted')
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()

      // const params = { ...this.flightDataFormModel }
      // params.user_id = this.$session.get('login-user').userId

      this.$refs.flightDataForm.validate()
        .then((valid) => {
          return this.$axios.put('/flight-data', this.flightDataFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.margeCustomerCodeSet(this.flightDataFormModel.operator_code)
          this.margeRegistrationSymbolSet(this.flightDataFormModel.registration_symbol)
          this.$emit('refresh')
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['operator_code', 'registration_symbol']
      this.$nextTick(() => {
        this.$refs.flightDataForm.clearFields()
        Object.keys(this.flightDataFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.flightDataFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
